module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Make It Happen: Surrender Your Fear: Take the Leap: Live On Purpose")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cts",
    attrs: {
      "id": "p0021-01-0"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/contents#con6",
      "id": "toc6"
    }
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct1a"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/contents#con6"
    }
  }, [_vm._v("SURRENDER YOUR FEAR")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620440c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter6.vue
// module id = 78
// module chunks = 0